import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './ArticleHeader.module.scss';

export default class ArticleHeaderComponent extends Component {
  static propTypes = {
    background: PropTypes.string.isRequired
  };

  render() {
    const { className, background } = this.props;

    return (
      <div className={`${styles.ArticleHeader} ${className}`}>
        <div
          className={styles.ArticleHeaderImage}
          style={{
            backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
              background
            )})`
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOffers/components/Article/ArticleHeader/ArticleHeader.js